import React from 'react';
import PropTypes from 'prop-types';

import './RoundButton.scss';

/**
 * Common Moo style RoundButton that can be extended
 */

const RoundButtonComponent = (props) => {
  const { disabled, icon, type, size, label } = props;
  const disabledClass = disabled ? 'round-button-component--disabled' : '';

  return (
    <button
      className={`round-button-component round-button-component--${type} ${disabledClass}`}
      disabled={disabled}
      onClick={props.onClick}
      onTouchEnd={props.onTouchEnd}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <span className={`round-button-component__icon round-button-component__icon--${size}`}>{icon}</span>
      {label ? <span className="round-button-component__label u-fontFamily-primaryMedium">{label}</span> : ''}
      {props.children}
    </button>
  );
};

RoundButtonComponent.displayName = 'RoundButton';

RoundButtonComponent.propTypes = {
  icon: PropTypes.element.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  label: PropTypes.string,
  onClick: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.element,
};

RoundButtonComponent.defaultProps = {
  disabled: false,
  type: 'primary',
  size: 'medium',
  onMouseEnter() {},
  onMouseLeave() {},
  onClick() {},
  onTouchEnd() {},
};

export default RoundButtonComponent;
